export class RequestData {
  abortController: AbortController;

  constructor(abortController: AbortController) {
    this.abortController = abortController;
  }
}

export class RequestsData {

  requests: RequestData[];

  constructor() {
    this.requests = [];
  }
}